import { AGENT_STATUS_LABEL } from '../../../core/constants/domain';
import { STATUS_SEQUENCE } from '../utils/agents';

import '../styles/status-legend.css';

export default function StatusLegend({ counts, value, onChange }) {
    return (
        <div className="status-legend" role="group" aria-label="Filtrar agentes por estado">
            {STATUS_SEQUENCE.map((status) => {
                const isActive = value === status;
                return (
                    <button
                        key={status}
                        type="button"
                        aria-pressed={isActive}
                        className={`status-legend__item status-legend__item--${status}${isActive ? ' status-legend__item--active' : ''}`}
                        onClick={() => onChange(isActive ? '' : status)}
                    >
                        <span className="status-legend__count">{counts[status] ?? 0}</span>
                        <span className="status-legend__label">{AGENT_STATUS_LABEL[status]}</span>
                    </button>
                );
            })}
        </div>
    );
}
